import _ from 'lodash'
import { isDedicatedDeskRoom } from '@wework/floormap-utils'

const RESERVABLE_DESK_TYPE = ['DEDICATEDDESK', 'HOTDESK']

export default class FilterManager {
  constructor(buildingIndexExtension, occupancyExtension) {
    this.buildingIndex = buildingIndexExtension
    this.occupancyExtension = occupancyExtension

    this.searchable = {}
  }

  async refreshSearchable(filterOptions) {
    if (_.get(filterOptions, 'commitmentDates')) {
      await this.occupancyExtension.getCommitments()
    }
    const indexTable = await this.buildingIndex.getIndexTable()
    const reservables = this.occupancyExtension.getReservables()
    const resultMap = {}
    _.forEach(indexTable, index => {
      // result[index.uuid] = index
      if (index.alias) {
        resultMap[index.alias] = {
          ...index,
          index,
          reservable: this.occupancyExtension.getDataBySpace(index),
        }
      } else {
        resultMap[index.uuid] = {
          ...index,
          index,
          reservable: this.occupancyExtension.getDataBySpace(index),
        }
      }
    })

    _.forEach(reservables, r => {
      _.forEach(r.matchedPhysicalUUIDs, puuid => {
        if (!resultMap[puuid]) {
          const record = {
            uuid: puuid,
            number: r.officeNumber,
            index: { ...(indexTable[puuid] || indexTable[r.alias]) },
            ...(indexTable[puuid] || indexTable[r.alias]),
          }

          if (record.index) {
            // If it is reservable desk type, if will remove window and internal room attributes
            if (RESERVABLE_DESK_TYPE.includes(r.type?.toUpperCase())) {
              record.index.hasWindow = false
              record.index.internalRooms = 0
            }
          }

          resultMap[puuid] = record
        }

        resultMap[puuid].reservable = r
      })
    })

    this.searchable = resultMap
  }

  async filter(filterOptions) {
    await this.refreshSearchable(filterOptions)

    const searchText = filterOptions.search
    const optionsWithoutSearch = { ...filterOptions }
    delete optionsWithoutSearch.search

    if (_.get(filterOptions, 'spaceType')) {
      const spaceTypes = _.get(filterOptions, 'spaceType')
      if (spaceTypes.includes('nook')) {
        spaceTypes.push('wt')
      }
    }

    let result = _.filter(this.searchable, item => {
      if (searchText) {
        let matchSearch = false
        if (item.reservable) {
          matchSearch = this.occupancyExtension.filterManager.isMatchFilter(
            item.reservable,
            {
              search: searchText,
            }
          )
        }

        if (!matchSearch && item.index) {
          matchSearch = this.buildingIndex.filterManager.isMatchFilter(
            item.index,
            {
              search: searchText,
            }
          )
        }

        if (!matchSearch) {
          return false
        }
      }

      // Search Occupancy
      const matchReservable = this.occupancyExtension.filterManager.isMatchFilter(
        item.reservable || {},
        optionsWithoutSearch
      )
      if (!matchReservable) {
        return false
      }

      // Search Physical
      const matchIndex = this.buildingIndex.filterManager.isMatchFilter(
        item.index || {},
        optionsWithoutSearch
      )
      if (!matchIndex) {
        return false
      }

      return true
    })

    result = this.aggregateSearchResult(result)
    return result
  }

  aggregateSearchResult = filteredIndex => {
    // Sanitize
    const parents = []
    let result = _.filter(filteredIndex, item => {
      const { index } = item

      if (index) {
        if (
          index.parentRoom &&
          ['CHAIR', 'TABLE'].includes(index.subType.toUpperCase())
        ) {
          const parent = this.searchable[index.parentRoom]
          if (!parent) {
            return false
          }

          if (isDedicatedDeskRoom(parent.subType, parent.roomTypeUUID)) {
            parents.push(parent.uuid)
            return true
          }

          return false
        }

        if (['WE', 'MEET', 'WORK'].includes(index.programType?.toUpperCase())) {
          if (
            index.programType.toUpperCase() === 'WE' &&
            !['PHONE BOOTH', 'NOOK'].includes(index.subType.toUpperCase())
          ) {
            return false
          }
        }

        if (['OPERATE', 'WASH'].includes(index.programType?.toUpperCase())) {
          return false
        }
      } else if (item.reservable && !item.reservable.alias) {
        return false
      }

      return true
    })

    result = result.filter(item => !parents.includes(item.uuid) && item.number)

    return result
  }
}
